import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["radio", "datepicker"];

  connect() {
    this.updateDatepickerState(); // 初期状態を設定
  }

  change() {
    this.updateDatepickerState();
  }

  updateDatepickerState() {
    const isRadioChecked = this.radioTargets.some(
      (radio) => radio.checked && radio.classList.contains("js-search-handle-radio"),
    );
    this.datepickerTarget.disabled = !isRadioChecked;
  }
}
